import { PUBLIC_PTC_BILLING_KEY } from "../env";
import { loadScript } from "../lib/util";

export interface StripeIbanElement {
    mount(el: HTMLElement): void;
    addEventListener(event: "change" | "ready", handler: (e: { error?: { message?: string } }) => void): void;
}

interface StripeElements {
    create(type: "iban", options: { supportedCountries: string[]; placeholderCountry: string }): StripeIbanElement;
}

type SepaSetupResult =
    | { error: { message: string }; setupIntent?: never }
    | { error?: never; setupIntent: { payment_method: string } };

export interface StripeClient {
    elements(options: object): StripeElements;
    confirmSepaDebitSetup(
        clientSecret: string,
        data: {
            payment_method: {
                sepa_debit: StripeIbanElement;
                billing_details: { name: FormDataEntryValue | null; email: FormDataEntryValue | null };
            };
        }
    ): Promise<SepaSetupResult>;
}

let client: Promise<StripeClient> | undefined;

// Loaded on first use (opening the billing dialog), never at boot. Resolves
// null when no publishable key is configured for this environment.
export function loadStripe(): Promise<StripeClient | null> {
    if (!PUBLIC_PTC_BILLING_KEY) {
        return Promise.resolve(null);
    }
    client ??= loadScript<(key: string) => StripeClient>("https://js.stripe.com/v3/", "Stripe").then((Stripe) =>
        Stripe(PUBLIC_PTC_BILLING_KEY)
    );
    return client;
}
